import { FormatValue, SelectValueType } from '../types'

export const useFindOptionByValue = <TOption, TValue extends SelectValueType>(
  items: TOption[],
  formatValue: FormatValue<TOption, TValue>
) => {
  return (value: TValue) => items.find((item) => formatValue(item) === value)
}
